import { render, staticRenderFns } from "./CreateLayetteNew.vue?vue&type=template&id=06027e8f&style=display%3A%20inline-table%3B"
import script from "./CreateLayetteNew.vue?vue&type=script&lang=js"
export * from "./CreateLayetteNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports